/**
 * Default Reaction Design System Colors
 */

export default {
  // grey scale
  black: "#000000",
  black95: "#0d0d0d",
  black90: "#1a1a1a",
  black85: "#262626",
  black80: "#333333",
  black75: "#404040",
  black70: "#4d4d4d",
  black65: "#595959",
  black60: "#666666",
  black55: "#737373",
  black50: "#808080",
  black45: "#8c8c8c",
  black40: "#999999",
  black35: "#a6a6a6",
  black30: "#b3b3b3",
  black25: "#bfbfbf",
  black20: "#cccccc",
  black15: "#d9d9d9",
  black10: "#e6e6e6",
  black05: "#f5f5f5",
  black02: "#fafafa",
  white: "#ffffff",

  // medium colors
  reactionBlue: "#1999dd",
  reactionBlue100: "#ecf8fe",
  reactionBlue200: "#d6e5ed",
  reactionBlue300: "#26b0f9",
  reactionBlue400: "#067ebe",
  reactionBlue500: "#285268",
  reactionBlue600: "#172f3c",
  reactionBlueActive: "#057dbe",
  reactionBlueHover: "#25b0f9",
  reactionBlueBackground: "#F5FBFE",
  reactionBlueBorder: "#C4E3F6",

  coolGrey: "#5e7480",
  coolGrey100: "#e3ebf0",
  coolGrey200: "#d5d5d5",
  coolGrey300: "#5d8ea9",
  coolGrey400: "#3c5d6f",
  coolGrey500: "#3c3c3c",
  coolGrey600: "#1d1d1d",
  coolGreyActive: "#3b5c70",
  coolGreyActiveLight: "#c9d9e1",
  coolGreyHover: "#5d8fa9",
  coolGreyHoverLight: "#eaeff3",

  paleGrey: "#e9f0f4",
  lightBlueGrey: "#c8d9e3",

  // dark colors
  forestGreen: "#158562",
  forestGreen100: "#dcfaf1",
  forestGreen200: "#b4ddc1",
  forestGreen300: "#0db781",
  forestGreen400: "#066144",
  forestGreen500: "#285749",
  forestGreen600: "#1e4035",
  forestGreenBackground: "#EDFCF8",
  forestGreenBorder: "#BCDFD2",

  darkBlue: "#23566d",
  darkBlue100: "#d9ebf3",
  darkBlue200: "#c4d3da",
  darkBlue300: "#135471",
  darkBlue400: "#103a4d",
  darkBlue500: "#333f45",
  darkBlue600: "#242c30",

  // support colors
  yellow: "#efc95f",
  yellow100: "#fcf3dc",
  yellow200: "#e9e1cb",
  yellow300: "#fdda79",
  yellow400: "#fbc120",
  yellow500: "#a2832d",
  yellow600: "#7a6322",
  yellowBackground: "#FEF9ED",
  yellowBorder: "#E6DBBE",

  red: "#cd3f4c",
  red100: "#ffeeef",
  red200: "#f0e8e9",
  red300: "#e54f5d",
  red400: "#bc1d2b",
  red500: "#5e3033",
  red600: "#3c1f21",
  redHover: "#e4505e",
  redBackground: "#FEF6F7",
  redBorder: "#F4C9CC",

  teal: "#8ce0c9",
  teal100: "#edfdf8",
  teal200: "#d9ece6",
  teal300: "#a3f2dc",
  teal400: "#55e4be",
  teal500: "#447467",
  teal600: "#34584f"
};
